import CategoryScreen from './CategoryScreen';

export default CategoryScreen;
